module.exports = __webpack_public_path__ + "37fb0190fbb2c617273a82665aca62f2.png";